import React, { useContext, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";
import { AccountMergeResultLayer } from "../../../components/UI/Dialog";
import { _O } from "../../../modules/utils";
import { getCookie } from "../../../modules/utils/cookie";
import { maxLengthCheck } from "../../common/maxLengthCheck/maxLengthCheck";
import { Header } from "./Header";

export const ChangePhoneNumber = (props) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [inputPw, setInputPw] = useState();
  const [dialog, setDialog] = useState({
    type: "check",
    title: "",
    msg: "회원정보가 일치하지 않습니다",
    msg2: "",
    data: {},
  });

  const checkUserAccount = () => {
    // console.log(inputPw);
    if (!inputPw || inputPw.length == 0) {
      alert("전화번호를 입력하세요");
    } else if (inputPw.length < 11) {
      alert("전화번호를 확인하세요");
    } else {
      _O.Open("/membership/certi/CHANGE/" + userinfo.userToken + "/" + inputPw);
    }
  };

  const backUrlEvent = () => {
    if (getCookie("signUpChannel") === "000") {
      window.history.back();
    } else {
      _O.Open("/mp/myInfo/view");
    }
  };

  return (
    <ContainerWhite>
      <Header backUrl={backUrlEvent} />
      <Title>새 휴대폰번호</Title>
      <TextArea>
        <TextP>변경하실 휴대폰번호를 입력하세요</TextP>
      </TextArea>

      <div style={{ margin: "40px 16px 10px 16px" }}>
        <div
          style={{
            display: "flex",
            padding: "16px 14px",
            alignItems: "center",
            gap: "16px",
            flex: "1 0 0",
            borderRadius: "6px",
            border: "1px solid #d0d0d0",
          }}
        >
          <input
            type="number"
            pattern="\d*"
            style={{ border: "0px" }}
            placeholder="휴대폰번호를 입력하세요"
            onChange={(e) => {
              maxLengthCheck(11, e);
              setInputPw(e.target.value);
            }}
          />
        </div>
      </div>

      {/* <BottomBtn onClick={() => openLayerFn($("#acntMrgLayer"))}>확인 </BottomBtn> */}
      <BottomBtn
        active={inputPw && inputPw.length > 0 ? true : false}
        onClick={() => checkUserAccount()}
      >
        저장
      </BottomBtn>
      <AccountMergeResultLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={() => _O.Open("/mp/myInfo/view")}
        handleConfirmCBText={"확인"}
        setCookieBtn={false}
      />
    </ContainerWhite>
  );
};

export const ContainerWhite = styled.div`
  background: white;
`;

export const Title = styled.div`
  margin: 37px 16px 0px 16px;
  color: #000;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TextArea = styled.div`
  margin: 16px 16px 0px 16px;
`;

export const TextP = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const BottomBtn = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: ${(props) => (props.active ? "1px solid #333" : "1px solid #CCC")};
  background: ${(props) => (props.active ? "#333" : "#ccc")};

  color: #fff;
  font-family: Malgun Gothic;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  margin: 0 16px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 32px);
`;
